import { evaluateConditionGroup, } from '../../conditions/conditions';
import { RuntimeOperations } from '../runtimeProcessing';
import { containsOperationRuntimeConfig, createRuntimeOperationType, } from './common';
export const filterListOperationType = createRuntimeOperationType({
    kind: 'FILTER_LIST',
    dependencies: () => [],
    run: (value, context) => {
        if (!Array.isArray(value)) {
            throw new Error(`FILTER_LIST input must be an array. Got ${JSON.stringify(value)}`);
        }
        const [list, condition] = value;
        if (!list) {
            return list;
        }
        if (list.length === 0) {
            return [];
        }
        const filteredItems = [];
        if (containsOperationRuntimeConfig(list)) {
            return list;
        }
        for (const item of list) {
            const processedCondition = RuntimeOperations.processValue({
                ...context,
                item,
            })(condition);
            if (containsOperationRuntimeConfig(processedCondition)) {
                return list;
            }
            if (evaluateConditionGroup(processedCondition)) {
                filteredItems.push(item);
            }
        }
        return filteredItems;
    },
});
//# sourceMappingURL=filter-list.js.map